// Tracks which sides already had an on-demand preview generation request fired
// (e.g. sides skipped during upload via options.onUpload.generatePreviewForSides),
// so we don't send duplicate requests while the preview is still being generated.
const requestedSideIds = new Set<string>();

export const hasRequestedSidePreview = (sideId: string): boolean => requestedSideIds.has(sideId);

export const markSidePreviewRequested = (sideId: string): void => {
  requestedSideIds.add(sideId);
};

export const clearSidePreviewRequested = (sideId: string): void => {
  requestedSideIds.delete(sideId);
};
